(function () {

    "use strict";

    function PropertyesDocuViewerModelFactory($translate) {

        function PropertyesDocuViewerModel() {
            this.id = "";
            this.width = "100%";
            this.height = "100%";
            this.showqueuepsadosnapin = true;
            this.showpanelheadersnapin = true;
            this.showbotonessnapin = true;
            this.showbotonqueuepsar = true;
            this.showanotaciones =  false;
            this.showsearch = true;
            this.showthumbnails = true;
            this.enableabrir =  false;
            this.enableabriruri = false;
            this.enabletwain = false;
            this.enableguardar = false;
            this.enableprint = false;
            this.showtoolbar =  true;
            this.canrellenarcampospdf = false;
            this.showbookmark =  true;
            this.language = $translate.use();
        }

        PropertyesDocuViewerModel.prototype.deserialize = function (data) {
             this.id = data.id;
             this.width = data.width;
             this.height = data.height;
             this.showqueuepsadosnapin = data.showqueuepsadosnapin;
             this.showpanelheadersnapin = data.showpanelheadersnapin;
             this.showbotonessnapin = data.showbotonessnapin;
             this.showbotonqueuepsar = data.showbotonqueuepsar;
             this.showanotaciones = data.showanotaciones;
             this.showsearch = data.showsearch;
             this.showthumbnails = data.showthumbnails;
             this.enableabrir = data.enableabrir;
             this.enableabriruri = data.enableabriruri;
             this.enabletwain = data.enabletwain;
             this.enableguardar = data.enableguardar;
             this.enableprint = data.enableprint;
             this.showtoolbar = data.showtoolbar;
             this.canrellenarcampospdf = data.canrellenarcampospdf;
             this.showbookmark = data.showbookmark;
             this.language = data.language;
             return this;
        };

        return PropertyesDocuViewerModel;
    }

    PropertyesDocuViewerModelFactory.$inject = ["$translate"];

    angular.module("solpheo")
        .factory("solpheo.propertyesDocuViewer", PropertyesDocuViewerModelFactory);
}());